<template>
  <div class="flex overflow-x-auto py-2 will-change-scroll">
    <chat-forward-message-selected-contacts-list-item
      v-for="room in items"
      :key="room.pServedUser"
      :room="room"
      class="mr-4 shrink-0"
      @remove="onRemove($event)"
    />
  </div>
</template>
<script lang="ts" setup>
import { PServed } from '@wui/im'

import { Room } from '@/shared/types/store'

import ChatForwardMessageSelectedContactsListItem from './chat-forward-message-selected-contacts-item.vue'

defineProps<{
  items: Room[],
}>()

const emit = defineEmits<{
  (event: 'remove', pServed: PServed): void;
}>()

const onRemove = (pServed: PServed): void => {
  emit('remove', pServed)
}
</script>
